// hooks/UseAuthToken.js
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const useAuthToken = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState(null);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      // 1) Passwordless token wins
      const passwordless = localStorage.getItem("vibeu_access_token");
      if (passwordless) {
        if (alive) setToken(passwordless);
        return;
      }

      // 2) Otherwise Auth0 SDK token
      if (!isAuthenticated) {
        if (alive) setToken(null);
        return;
      }

      try {
        const t = await getAccessTokenSilently();
        if (alive) setToken(t);
      } catch (e) {
        if (alive) setToken(null);
      }
    };

    // initial run
    run();

    // 🔔 re-run when we explicitly broadcast auth changes
    const handleAuthChanged = () => {
      run();
    };

    window.addEventListener("vibeu-auth-changed", handleAuthChanged);

    // (optional) if you ever log in from another tab, this will help too
    window.addEventListener("storage", handleAuthChanged);

    // cleanup
    return () => {
      alive = false;
      window.removeEventListener("vibeu-auth-changed", handleAuthChanged);
      window.removeEventListener("storage", handleAuthChanged);
    };
  }, [isAuthenticated, getAccessTokenSilently]);

  return token;
};
